import { render, staticRenderFns } from "./FruitGuide.vue?vue&type=template&id=7b27823e"
import script from "./FruitGuide.vue?vue&type=script&lang=js"
export * from "./FruitGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports